export default class CNPJUtils {
	static WEIGHTS_1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
	static WEIGHTS_2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

	static isValidCNPJ(cnpj) {
		if (typeof cnpj !== 'string') return false

		cnpj = cnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

		if (cnpj.length !== 14 || /^(\d)\1*$/.test(cnpj) || !/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpj)) return false

		try {
			const getNumeric = (c) => c.charCodeAt(0) - 48
			const digits = cnpj.split('').map(getNumeric)

			const sum1 = digits.slice(0, 12).reduce((sum, digit, index) => sum + digit * this.WEIGHTS_1[index], 0)
			const check1 = sum1 % 11 < 2 ? 0 : 11 - (sum1 % 11)

			const sum2 = digits.slice(0, 13).reduce((sum, digit, index) => sum + digit * this.WEIGHTS_2[index], 0)
			const check2 = sum2 % 11 < 2 ? 0 : 11 - (sum2 % 11)

			return check1 === digits[12] && check2 === digits[13]
		} catch (e) {
			return false
		}
	}
}
